// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__gTKMg","content":"Footer_content__J0bbA","link":"Footer_link__WNNV2","links":"Footer_links__V5NeJ","copy":"Footer_copy__kmkUS"};